import React, { useEffect } from 'react';
import _ from 'lodash'
import { connect } from 'react-redux'
import { SegmentedButton, Button } from '@sencha/ext-modern'

import FormMessage from '../FormMessage'
import { useInstData, useEventHandler } from 'tyan/public/hooks'
import Tab from './Tab'

const Task = props => {
	const { me, setState } = useInstData(props)

	const { task, that, reloadStamp } = props
	let { currentTab = null } = me.state
	// check if currTab is visible
	currentTab && !currentTab.total && currentTab.total != undefined && (currentTab = null)

	const handleTabChange = useEventHandler((e, v) => {
		const newTab = task.tabs.find(t => t.name == v)
		currentTab != newTab && setState({ currentTab: newTab })
	})

	const genTabSwitcher = () => {
		return <SegmentedButton defaultUI="toolbar-default" value={currentTab && currentTab.name} onChange={handleTabChange} margin="0 10 0 0">
			{task.tabs.reduce((s, t) => ((t.total || t.total == undefined) && s.push(<Button noLocale key={t.name} value={t.name} text={`${Tyan.t(t.name, 'tab')}(${t.total || '?'})`} />), s), [])}
		</SegmentedButton>
	}

	useEffect(() => {
		const newTab = task && task.tabs.find(t => t.total || t.total == undefined)
		!currentTab && newTab && setState({ currentTab: newTab })
	})

	return !task ? <FormMessage text={'加载中 ...'} /> :
		currentTab && <Tab key={currentTab.name} tab={currentTab} toolPart={genTabSwitcher()} that={that} reloadStamp={reloadStamp} /> || null
}

export default connect()(Task)